<template>
  <div class="wapper">
    <el-container style="100%">
      <el-main style="background: #fff">
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3">
            <el-form
                :inline="true"
                ref="form"
                :model="searchForm"
                class="demo-form-inline"
            >
              <div class="uers-left">
                <el-form-item label="搜索：">
                  <el-input
                      v-model="searchForm.name"
                      placeholder="名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                      v-model="searchForm.remark"
                      placeholder="描述"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                      v-model="searchForm.exhibitorId"
                      placeholder="选择展商"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                        v-for="(type, index) in exhibitors"
                        :label="type.name + ',' + type.company"
                        :key="index"
                        :value="type.exhibitorId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-button
                    type="primary"
                    icon="el-icon-search"
                    @click="searchSubmit()"
                >搜索
                </el-button
                >
              </div>
              <div class="uers-right">
                <span class="btn-r">
                  <el-button
                      type="primary"
                      plain
                      icon="el-icon-plus"
                      @click="addSubmit"
                  >新增</el-button
                  >
                </span>
              </div>
            </el-form>
          </div>
          <div class="tabbox">
            <el-table
                :data="dataList"
                height="100%"
                border
                class="tabbox"
                ref="multipleTable"
                :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
                @selection-change="handleSelectionChange"
            >
              <el-table-column
                  type="selection"
                  width="55"
                  align="center"
              ></el-table-column>
              <el-table-column prop="name" label="名称" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="company" label="公司" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.company }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="booth" label="展位" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.booth }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="phone" label="描述" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.remark }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="url" label="图片" align="center">
                <template slot-scope="scope">
                  <div class="demo-image__preview">
                    <el-image
                        style="width: 40px; height: 40px"
                        :preview-src-list="[scope.row.url]"
                        :src="scope.row.url"
                    ></el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="state" label="状态" align="center">
                <template slot-scope="scope">
                  <span>{{
                      scope.row.state == 1
                          ? "未审核"
                          : scope.row.state == 2
                              ? "已审核"
                              : "已拒绝"
                    }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="createDate"
                  label="创建时间"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                      type="text"
                      @click="handleEdit(scope.$index, scope.row)"
                  >编辑
                  </el-button
                  >
                  <el-button
                      type="text"
                      class="red"
                      @click="handleDelete(scope.$index, scope.row)"
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fb">
            <el-pagination
                class="pag"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            ></el-pagination>
          </div>
        </div>
        <DeleteDialog
            :delVisible="delVisible"
            @deleteData="deleteData"
            @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
        <EditExhibition
            :editShow="editShow"
            :editData="editData"
            @backFunStu="getFunStu"
        ></EditExhibition>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import EditExhibition from "../../../components/major/businessman/EditExhibitorExhibit";
import DeleteDialog from "../../../components/public/DeleteConfim";

export default {
  data() {
    return {
      total: 0, //总条数
      currentPage: 1, //初始页
      pagesize: 10, // 每页的数据
      searchForm: {
        name: "",
        remark: "",
        exhibitorId: "0",
      },
      exhibitors: [],
      editData: {},
      listShow: true,
      editShow: false,
      delVisible: false,
      dataList: [],
      multipleSelection: [],
      productId: "",
      exhibitor_Id: "",
    };
  },
  mounted() {
  },
  created() {
    var product_id = localStorage.getItem("project_Id");
    this.productId = product_id;
    this.$axios.get("/Exhibitor/Project/" + product_id).then((res) => {
      if (res.data.hasError == false) {
        this.exhibitors = [...res.data.data];
      }
    });

    this.getData();
  },
  methods: {
    handleSizeChange(val) {
      this.pagesize = val;
      this.getData();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(`当前页: ${val}`);
      this.getData();
    },
    addSubmit() {
      this.exhibitor_Id = "";
      this.editData = null;
      this.listShow = false;
      this.editShow = true;
    },
    searchSubmit() {
      var search = {
        name: this.searchForm.name,
        remark: this.searchForm.remark,
        exhibitorId: this.searchForm.exhibitorId,
        pageIndex: this.currentPage - 1,
        pageSize: this.pagesize,
        projectId: this.productId,
      };
      this.$axios.post("/ExhibitorProduct/Search", search).then((res) => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data];
          this.total = res.data.total;
        }
      });
    },
    handleDelete(index, row) {
      this.exhibitor_Id = row.exhibitorProductId;
      this.delVisible = true;
    },
    handleCloseVisible() {
      this.exhibitor_Id = "";
      this.delVisible = false;
    },
    deleteData() {
      this.$axios
          .delete(`/ExhibitorProduct/${this.exhibitor_Id}`)
          .then((res) => {
            if (res.data.hasError) {
              this.$message.error(res.data.message);
            } else {
              this.$message.success("删除成功！");
              this.delVisible = false;
              this.getData();
            }
          });
    },
    // 获取数据
    getData() {
      this.currentPage = 1;
      this.searchSubmit();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(index, row) {
      this.editData = row;
      this.listShow = false;
      this.editShow = true;
    },
    getFunStu() {
      this.listShow = true;
      this.editShow = false;
      this.getData();
    },
  },
  components: {
    EditExhibition,
    DeleteDialog,
  },
};
</script>
<style lang="scss" scope>
.pag {
  position: absolute;
  bottom: 0;
}

.table-wrap {
  margin-left: 10px;
  height: 100%;
}

.el-main {
  border-radius: 5px;
  position: relative;
}

.uers-left {
  float: left;
}

.uers-right {
  float: right;
}

.import-bnt {
  float: right;
}

.el-upload--text {
  border: 0;
}
</style>